import { Component, OnInit, Input } from '@angular/core';
import { ParametersService } from '../../service/parameters.service';
import { ToastService } from '../../service/toast.service';
import { Settings } from '../../model/settings.model';
import { TchekStatus } from '../../model/search';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-parameters-language',
  templateUrl: './parameters-language.component.html',
  styleUrls: ['./parameters-language.component.less']
})
export class ParametersLanguageComponent implements OnInit {
  @Input() language: string;
  @Input() company: boolean;
  timerEvent: NodeJS.Timer;
  readonly lngValue = [
    new TchekStatus('fr', 'Francais'),
    new TchekStatus('de', 'Deutsch'),
    new TchekStatus('en', 'English'),
    new TchekStatus('nl', 'Nederlands'),
  ];

  handlerChange(event) {
    this.sendData()
  }

  sendData() {
    clearTimeout(this.timerEvent);
    this.timerEvent = setTimeout(() => {
      console.log("language", this.language);
      this._toastService.toastOpen(true);
      this._parametersService.saveLanguage(this.language, this.company).then((saved: Settings) => {
        this.language = saved.language;
        this._toastService.toastOpen(false);
      });
    }, 500);
  }

  constructor(private readonly _parametersService: ParametersService,
    private readonly _toastService: ToastService) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/parameters-language/parameters-language.component.ts